import React from 'react';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';

const CardLayout = styled.div`
  border: 1px solid ${colors.silt};
  border-radius: 8px;
  overflow: hidden;
`;

const CardHeader = styled.div`
  background-color: rgb(67, 145, 139);
  color: white;
  padding: 12px 20px;
  font-size: 18px;
  font-weight: 600;
`;

const CardContent = styled.div`
  display: grid;
  gap: 16px;
  padding: 20px;
`;

interface SectionCardProps {
  title: string;
  children: React.ReactNode;
}

const SectionCard: React.FC<SectionCardProps> = ({ title, children }) => (
  <CardLayout>
    <CardHeader>{title}</CardHeader>
    <CardContent>{children}</CardContent>
  </CardLayout>
);

export default SectionCard;
